// extracted by mini-css-extract-plugin
export var featureBlock = "feature-block-module--feature-block--70CHT";
export var title = "feature-block-module--title--16G6p";
export var subtitle = "feature-block-module--subtitle--F1cWu";